// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Dict from "@rescript/core/src/Core__Dict.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

let registry = {};

let changeListeners = {
  contents: []
};

function addChangeListener(cb) {
  changeListeners.contents = changeListeners.contents.concat([cb]);
}

function removeChangeListener(cb) {
  changeListeners.contents = changeListeners.contents.filter(l => l !== cb);
}

function notify() {
  changeListeners.contents.forEach(cb => cb());
}

function installPort(key, epoch, port) {
  let existing = registry[key];
  if (existing !== undefined) {
    if (existing.epoch === epoch) {
      return;
    }
    try {
      existing.port.close();
    } catch (exn) {
      
    }
    registry[key] = {
      port: port,
      epoch: epoch
    };
    return notify();
  }
  registry[key] = {
    port: port,
    epoch: epoch
  };
  notify();
}

function getPort(key) {
  return Core__Option.map(registry[key], h => h.port);
}

function closePort(key) {
  let handle = registry[key];
  if (handle === undefined) {
    return;
  }
  try {
    handle.port.close();
  } catch (exn) {
    
  }
  Core__Dict.$$delete(registry, key);
  notify();
}

function postFrame(key, frame) {
  let handle = registry[key];
  if (handle === undefined) {
    return false;
  }
  try {
    handle.port.postMessage(frame);
    return true;
  } catch (exn) {
    return false;
  }
}

export {
  registry,
  changeListeners,
  addChangeListener,
  removeChangeListener,
  notify,
  installPort,
  getPort,
  closePort,
  postFrame,
}
/* No side effect */
